"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsReporter = void 0;
/**
 * An alias for reporting either search analytics events.
 * Maintained for backward compatibility with previous versions of this library.
 *
 * @public
 * @inheritDoc SearchAnalyticsReporter
 */
var SearchAnalyticsReporter_1 = require("./SearchAnalyticsReporter");
Object.defineProperty(exports, "AnalyticsReporter", { enumerable: true, get: function () { return SearchAnalyticsReporter_1.SearchAnalyticsReporter; } });
//# sourceMappingURL=AnalyticsReporter.js.map